<div class="flex flex-wrap items-center gap-x-6 gap-y-1 border-b border-stroke-primary-8 px-2 pb-2">
  @for (site of sites(); track site.id) {
    <div class="flex items-center gap-[6px]">
      <div class="shrink-0 w-[12px] h-[12px] rounded-radius-circle" [style.background-color]="site.color"></div>
      <div class="text-sm text-foreground-primary-60">
        {{ 'multi-site-dashboard.energy-cost-overview.energy' | translate }}
        @if (!isEnergyAggregated()) {
          - <span class="font-semibold">{{ site.name }}</span>
        }
      </div>
    </div>
  }

  <div class="flex items-center gap-[6px]">
    <div class="shrink-0 w-[12px] h-[12px] rounded-radius-circle bg-status-warning"></div>
    <div class="text-sm text-foreground-primary-60">{{ 'multi-site-dashboard.energy-cost-overview.cost' | translate }}</div>
  </div>
</div>
